import { Component, Prop, Vue } from 'vue-property-decorator';
import {  itiHttpService, itiSignalRService, i18n, itiMessageService } from '@/iti-core-vue';
import DxList from 'devextreme-vue/list';
import eventModule from '@/store/modules/event.module';
import moment from 'moment';

@Component({
    components: {    
        DxList    
    },
})
export default class NextEvents extends Vue {

    @Prop() public mode!: string;
    @Prop() public idArea!: number; 
    @Prop() public idType!: number    

    public get nextEvents(){                
        return eventModule.nextEvents;
    }

    public mounted() {        
        switch(this.mode){
            case "User": {                
                eventModule.getNextEventsFromUser().catch( () => {itiMessageService.toast(this.$tc('mensajes-plantillas.info-error'), 'error', 2000);});
                break;
            }
            case "CollaborativeArea": {                               
                eventModule.getNextEventsByAmbitId(this.idArea).catch( () => {itiMessageService.toast(this.$tc('mensajes-plantillas.info-error'), 'error', 2000);});
                break;
            }
            case "AreaType": {
                eventModule.getNextEventsFromUserByAreaType(this.idType).catch( () => {itiMessageService.toast(this.$tc('mensajes-plantillas.info-error'), 'error', 2000);});
                break;
            }
            default: {
                itiMessageService.toast(this.$tc('mensajes-plantillas.info-error'), 'error', 2000);        
                break;
            }                    
        }      
    }

    public getDate(date: Date) {          
        if (date.toString().charAt(0) == '0') { 
            return "";
        } else {         
            return moment(date).format('DD-MM-YYYY HH:mm');
        }
    }

    public goToCalendar() {
        if (this.mode == "User" || this.mode == "AreaType") {
            this.$router.push({ name: 'Calendario' });
        } else if (this.mode == "CollaborativeArea") {           
            this.$router.push({ name: 'CalendarioAreaColaborativa', params: { collaborativeAreaId: this.idArea.toString() } });            
        }
    }

    public goToNextEvent(e: any) {        
        this.$router.push({ name: 'CalendarioAreaColaborativa', params: { collaborativeAreaId: e.itemData.ambitId.toString() } });            
    }
}
  